module.exports = __webpack_public_path__ + "img/4_77.d3713099.png";